import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Generative AI Engineer",
          "Voice AI Developer",
          "LLM Pipeline Engineer",
          "Full Stack Developer",
          "Cloud-Native Architect",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
